module.exports = __webpack_public_path__ + "static/media/walkathon_share.6faec235.jpg";